export default __webpack_public_path__ + "static/powerquotes-6b86c468cc885d86289d511565f06324.mp3";